import React from 'react'
import { AppContainer } from './Babylon.styles'

const Babylon = () => {
  return (
    <AppContainer>
      <iframe src="/gemelo_digital.html" style={{ width: '100%', height: '100vh', border: 'none' }} />
    </AppContainer>
  )
}

export default Babylon
